<template>
  <div id="contact" class="mt-3">
    <h2>Contact us</h2>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-form-input
        id="input-name"
        v-model="form.name"
        required
        placeholder="Enter your name"
        class="mb-2"
      ></b-form-input>

      <b-form-input
        id="input-email"
        v-model="form.email"
        type="email"
        required
        placeholder="Enter your e-mail address"
        class="mb-2"
      ></b-form-input>

      <b-form-textarea
        id="input-message"
        v-model="form.message"
        required
        placeholder="Your message"
        rows="4"
        max-rows="6"
        class="mb-2"
      ></b-form-textarea>

      <vue-recaptcha
        sitekey="6LemgMgUAAAAAAQ4G1zStk9wu3digMzu4H5oARSV"
        :loadRecaptchaScript="true"
        @verify="verify"
      ></vue-recaptcha>
      
      <b-alert show variant="warning" v-if="!!recaptchaMessage" class="mt-2 mx-auto">{{recaptchaMessage}}</b-alert>

      <b-button type="submit" variant="primary" class="w-100 mt-2">Submit</b-button>
    </b-form>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";

export default {
  data() {
    return {
      form: {
        email: "",
        name: "",
        message: ""
      },
      show: true,
      recaptchaVerified: false,
      recaptchaMessage: ""
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();

      if (!this.recaptchaVerified) {
        this.recaptchaMessage = "Please tick the reCAPTCHA box.";
      }
    },
    onReset(evt) {
      evt.preventDefault();
      this.form.email = "";
      this.form.name = "";
      this.form.message = "";
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    verify() {
      this.recaptchaVerified = true;
      this.recaptchaMessage = '';
    }
  },
  components: { VueRecaptcha }
};
</script>